import EssentialLeftSection from "./EssentialLeftSection";
import EssentialRightSection from "./EssentialRightSection";

function PetTagEssential({ onClick }) {
  return (
    <div className="bg-[url('/assets/pet-tag/essential-bg.png')] bg-cover w-full h-auto lg:h-[837px] overflow-hidden text-pet-tag">
      <div className="flex flex-col items-center lg:flex-row">
        <EssentialLeftSection />

        <EssentialRightSection onClick={onClick} />
      </div>
    </div>
  );
}

export default PetTagEssential;
